import { useMemo } from 'react';

import Loader from '../Loader/Loader';
import PayAllElement from './PayAllElement';

import { StyledText } from '../../atoms/Text/StyledText';
import { StyledUserPanelTrainerPay } from '../../atoms/UserPanelTrainerPay/StyledUserPanelTrainerPay';
import { StyledPayWrapper } from '../../atoms/UserPanelTrainerPay/StyledPayWrapper';
import { StyledContent } from '../../atoms/UserPanelTrainerPay/StyledContent';
import { StyledButton } from '../../atoms/Button/StyledButton';
import { StyledButtonWrapper } from '../../atoms/UserPanelTrainerPay/StyledButtonWrapper';
import { StyledLoaderWrapper, StyledGlobalHeadingWrapper } from '../../../styles/sharedStyles';

import { listAllPay } from '../../../logic/requests/students';
import { getString } from '../../../strings';
import useScrollBar from '../../../logic/hooks/useScrollBar';
import UserPanelHeadingText from '../../atoms/UserPanel/UserPanelHeadingText';
import { useInfiniteQuery } from '@tanstack/react-query';
import CurrentMonthSummary from './Components/CurrentMonthSummary';

const UserPanelTrainerPay = () => {
    const { isScrollBar, scrollElement, trigger } = useScrollBar(true);

    const getPreviousMonth = (currentMonthStr) => {
        const [year, month] = currentMonthStr.split('-').map(Number);
        const date = new Date(year, month - 2, 1); // month jest 1-based, Date potrzebuje 0-based
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
    };

    const initialMonth = useMemo(() => {
        const now = new Date();
        return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
    }, []);

    const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading, refetch, isError } =
        useInfiniteQuery(
            ['listAllPay'],
            async ({ pageParam = initialMonth }) => {
                const res = await listAllPay(pageParam);
                return {
                    data: res,
                    currentMonth: pageParam,
                    nextCursor: res.hasNoMore ? undefined : getPreviousMonth(pageParam),
                };
            },
            {
                getNextPageParam: (lastPage) => lastPage.nextCursor,
                keepPreviousData: true,
            }
        );

    const hours = useMemo(() => {
        if (!data) return null;

        return data.pages.reduce((acc, page) => {
            const monthKeys = Object.keys(page.data).filter((key) => key !== 'hasNoMore');

            monthKeys.forEach((month) => {
                acc[month] = page.data[month];
            });

            return acc;
        }, {});
    }, [data]);

    const refreshData = () => refetch();

    return (
        <StyledUserPanelTrainerPay>
            {isLoading ? (
                <StyledLoaderWrapper>
                    <Loader />
                </StyledLoaderWrapper>
            ) : !data ? (
                <StyledLoaderWrapper>
                    <StyledText
                        hasdeclaredpadding="0px 20px"
                        hasdeclaredfontsize="22px"
                        hasdeclaredfontweight="700"
                        hasdeclaredtextalign="center"
                        hasdeclaredlineheight="1.4em"
                        as="p"
                    >
                        {getString(isError ? 'blad_wczytywania' : 'UserPanelTrainerPay__no_hours')}
                    </StyledText>
                </StyledLoaderWrapper>
            ) : (
                <>
                    <CurrentMonthSummary hours={hours} />
                    <StyledContent>
                        <StyledGlobalHeadingWrapper>
                            <UserPanelHeadingText text="Wynagrodzenie trenerów:" />
                        </StyledGlobalHeadingWrapper>
                        <StyledPayWrapper $isscrollbar={isScrollBar} ref={scrollElement}>
                            <PayAllElement
                                hours={hours}
                                trigger={trigger}
                                refreshData={refreshData}
                            />
                        </StyledPayWrapper>
                    </StyledContent>
                </>
            )}
            {hasNextPage ? (
                <StyledButtonWrapper haspadding>
                    <StyledButton onClick={() => fetchNextPage()}>
                        <StyledText
                            hasdeclaredfontsize="22px"
                            hasdeclaredfontweight="600"
                            hascursor="pointer"
                        >
                            {getString('Trainings_trainings_all_trainer_pay_zaladujWiecej')}
                        </StyledText>
                    </StyledButton>
                </StyledButtonWrapper>
            ) : (
                <StyledText
                    hasdeclaredfontsize="22px"
                    hasdeclaredfontweight="600"
                    hasdeclaredpadding="20px 0"
                    hasdeclaredtextalign="center"
                >
                    {getString('Trainings_trainings_all_trainer_pay_brakKolejnychMiesiecy')}
                </StyledText>
            )}
        </StyledUserPanelTrainerPay>
    );
};

export default UserPanelTrainerPay;
